import { Image } from 'antd';
import React, { useState, useEffect } from 'react';
import { apiHolder as api, apis, isSupportedConfig, getImageUrl, globalAdSpaceCode } from 'api';
import styles from './index.module.scss';
import CloseIcon from '@web-common/components/UI/Icons/svgs/CloseSvg';
import AdvertIcon from '@/images/icons/ad-tag-advert.svg';
import ActivityIcon from '@/images/icons/ad-tag-activity.svg';
const advertApi = api.api.requireLogicalApi(apis.advertApiImpl);
const systemApi = api.api.getSystemApi();
const storeApi = api.api.getDataStoreApi();
export const trackViewEvent = (config) => {
    config.advertResourceList[0].outsideStatisticsList.forEach(track => {
        if (track.type === 'VIEW') {
            advertApi.track(track);
            return;
        }
    });
};
export function getTag(config) {
    if (config.showTag !== 'YES') {
        return undefined;
    }
    if (config.operationType === 'ACTIVITY') {
        return ActivityIcon;
    }
    if (config.operationType === 'ADVERT') {
        return AdvertIcon;
    }
    return undefined;
}
const UserCloseGlobalAdSpaceKey = 'user_close_global_ad_space_key';
export const GlobalAdSpace = () => {
    const [adConfigs, setAdConfigs] = useState([]);
    const [shouldShowAd, SetShouldShowAd] = useState(true);
    const fetchAdConfig = async () => {
        const response = await advertApi.fetchConfig(globalAdSpaceCode);
        if (response.data) {
            const temp = response.data['itemList'] || [];
            const filterTemp = temp.filter(t => {
                const res = t.advertResourceList[0];
                return res && res.source === 'DIRECT_CASTING' && (res.type === 'PIC' || res.type === 'CUSTOM');
            });
            setAdConfigs(filterTemp || []);
            if (filterTemp[0]) {
                trackViewEvent(filterTemp[0]);
            }
        }
        else {
            setAdConfigs([]);
        }
    };
    const getImageContent = (config) => {
        const imageModel = config.advertResourceList[0].content;
        return imageModel;
    };
    useEffect(() => {
        const store = storeApi.getSync(UserCloseGlobalAdSpaceKey);
        if (store.data === 'true') {
            SetShouldShowAd(false);
        }
    }, [shouldShowAd]);
    useEffect(() => {
        fetchAdConfig();
    }, []);
    const adDidClick = (config) => {
        const link = getImageContent(config).clickUrl;
        if (link && link.length > 0) {
            systemApi.openNewWindow(link);
        }
        config.advertResourceList[0].outsideStatisticsList.forEach(track => {
            if (track.type === 'CLICK') {
                advertApi.track(track);
                return;
            }
        });
    };
    const cancelButtonClick = () => {
        storeApi.putSync(UserCloseGlobalAdSpaceKey, 'true', { noneUserRelated: false });
        SetShouldShowAd(false);
    };
    return adConfigs.length === 0 || !shouldShowAd || !isSupportedConfig(adConfigs[0]) ? null : (React.createElement("div", { className: styles.globalAd },
        React.createElement("div", { className: styles.closeIcon, onClick: () => {
                cancelButtonClick();
            } },
            React.createElement(CloseIcon, null)),
        React.createElement("div", { className: styles.imageRoot },
            React.createElement(Image, { className: styles.imageView, onClick: () => {
                    adDidClick(adConfigs[0]);
                }, preview: false, src: getImageUrl(adConfigs[0]) }))));
};
